import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { useQueryVerifyMagicLink } from "../hooks/react-query/useData";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

export default function MagicLinkCallback() {
  const navigate = useNavigate();
  const { token } = useParams(); // <-- token comes from the URL path

  const { isError, isSuccess } = useQueryVerifyMagicLink(token);
  const [message, setMessage] = useState("Verifying magic link...");

  useEffect(() => {
    if (isSuccess) {
      setMessage("Enlace verificado correctamente! Redireccionando...");
      const timer = setTimeout(() => navigate("/dashboard"), 1500);
      return () => clearTimeout(timer);
    }
  }, [isSuccess, navigate]);

  useEffect(() => {
    if (isError) {
      setMessage("Link invalid or expired. Redirecting...");
      toast.error("Enlace invalido o expirado");
      const timer = setTimeout(() => navigate("/"), 1500);
      return () => clearTimeout(timer);
    }
  }, [isError, navigate]);

  return (
    <Container
      maxWidth="sm"
      sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}
    >
      <Box textAlign="center">
        <CircularProgress />
        <Typography mt={2}>{message}</Typography>
      </Box>
    </Container>
  );
}